export enum ELocalStorage {
  ACCESS_TOKEN = 'token',
  USER = 'user',
  AUTH_SESSION_STARTED_AT = 'authSessionStartedAt',
  PORTFOLIO_CSV_DATA = 'portfolioCsvData',
  DASHBOARD_TOUR = 'dashboardTourViewed',
  DASHBOARD_TOUR_V2 = 'dashboardTourViewed-v2',
  DAILY_AUTH_STATE_PREFIX = 'daily-auth-state:',
  ALERT_SECTION_READ_PREFIX = 'alert-section-read:',
  LIQUIDITY_PROVIDERS = 'liquidity-providers-ratings',
  DOCS_NAV_COLLAPSED = 'docs-nav-collapsed',
}

export enum ESessionStorage {
  AUTH_SESSION_STARTED_AT = 'authSessionStartedAt',
  MONITORING_NOTIFICATION_BADGE = 'monitoringNotificationBadge',
  RT_KEY = 'returnTo',
  PR_KEY = 'pendingRedirect',
  DASHBOARD_TABLE_SETUP = 'dashboard:filter&sort-v2',
}
